import { Box, BoxProps, Image, TextProps } from '@jfs/ui-new'

export const PoweredBy = () => {
  return (
    <Box {...styles.poweredBy} p={8}>
      <Box>
        <Image source={'bharatbillpay'} resizeMode="contain" width={75} height={27} />
      </Box>
    </Box>
  )
}

const styles = {
  poweredBy: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  } as BoxProps,
  poweredTxt: {
    color: 'LIGHT_GREY',
    fontSize: 12,
    fontFamily: 'SourceSans3-Medium',
  } as TextProps,
  border: {
    borderTopWidth: 1,
    width: '100%',
    borderColor: 'BORDER_COLOR',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
}
